import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import { Property } from 'csstype';
import * as Constants from "../../../Constants"
import * as adminStyles from '../../AdminStyles.css';
import * as styles from "../DesignSettingsPanel.css";
import { IAColorPicker } from '../../../../colorPicker/ColorPicker';
import { IADropDown } from '../../../../dropDown/DropDown';
import { IAToggle } from '../../../../toggle/Toggle';
import { LocalizationService } from '../../../../../services/LocalizationService';

export interface IElementGroupsSettingsProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export default class ElementGroupsSettings extends React.Component<IElementGroupsSettingsProps, {}> {

  private readonly localizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.pivotContentItem}
        style={{
          height: 1200
        }}
      >
        <IAColorPicker
          label={this.localizationService.strings.Navigator_Design_BackgroundColor}
          color={this.props.navigatorStore.navigator.design.elementGroups.backgroundColor}
          onChange={(backgroundColor: string) => this.props.navigatorStore.setElementGroupBackgroundColor(backgroundColor)}
          showClearButton={false}
        />
        <IAColorPicker
          label={this.localizationService.strings.Navigator_Design_TextColor}
          color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
          onChange={(color: string) => this.props.navigatorStore.setElementGroupTextColor(color)}
          showClearButton={false}
        />
        <div className={adminStyles.panelDivider} />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_FontSize}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.fontSize as string}
          options={Constants.FONT_SIZES}
          onChange={(fontSize: Property.FontSize<number>) => this.props.navigatorStore.setElementGroupFontSize(fontSize)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_FontWeight}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.fontWeight as string}
          options={Constants.FONT_WEIGHTS}
          onChange={(fontWeight: string) => this.props.navigatorStore.setElementGroupFontWeight(fontWeight)}
          style={{ width: 155, float: "left", clear: "none", marginLeft: 20 }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_TextTransform}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.textTransform}
          options={Constants.TEXT_TRANSFORMS}
          onChange={(textTransform: Property.TextTransform) => this.props.navigatorStore.setElementGroupTextTransform(textTransform)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_LetterSpacing}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.letterSpacing}
          options={Constants.LETTER_SPACING}
          onChange={(letterSpacing: string) => this.props.navigatorStore.setElementGroupLetterSpacing(letterSpacing)}
          style={{ width: 155, float: "left", clear: "none", marginLeft: 20 }}
          borderRadius={5}
        />
        <IADropDown
          label={"Padding"}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.padding ?? "20px"}
          options={Constants.NAVIGATOR_PADDING}
          onChange={(padding: string) => this.props.navigatorStore.setElementGroupPadding(padding)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <div className={adminStyles.panelDivider} />
        <IAToggle
          label={this.localizationService.strings.Navigator_Design_LineShow}
          checked={this.props.navigatorStore.navigator.design.elementGroups.showLine}
          color={this.props.navigatorStore.adminColor}
          onChange={() => {
            this.props.navigatorStore.toggleElementGroupLine();
            this.forceUpdate();
          }}
          style={{
            clear: "both",
            marginTop: 20
          }}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_LineThickness}
          selectedOption={this.props.navigatorStore.navigator.design.elementGroups.lineThickness}
          options={Constants.LINE_THICKNESS}
          onChange={(lineThickness: string) => this.props.navigatorStore.setElementGroupLineThickness(lineThickness)}
          borderRadius={5}
        />
        <div className={adminStyles.panelDivider} />
        <IAColorPicker
          label={this.localizationService.strings.Navigator_Design_IconColor}
          color={this.props.navigatorStore.navigator.design.elementGroups.iconColor != undefined ? this.props.navigatorStore.navigator.design.elementGroups.iconColor : this.props.navigatorStore.adminColor}
          onChange={(color: string) => this.props.navigatorStore.setElementGroupIconColor(color)}
          showClearButton={false}
        />
        <div className={adminStyles.panelDivider} />
      </div>
    );
  }
}